"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-blog-hero__swiper");
        if (!initSlider) return;

        const swiper = new Swiper(".o-blog-hero__swiper", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 26,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: ".o-blog-hero__nav--next",
                prevEl: ".o-blog-hero__nav--prev",
            },
        });
    });
}
